import { toDate } from "@/utils/date.utils";
import {
    formatText
} from "@/utils/text.utils"
import config from "@/constants/config"
import links from "@/constants/links";
import store from "@/plugins/store"
import actions from "@/store/actions"


/**
 * Get posts and optionally filter by slug
 * @param {string} posts
 * @param {string} slug
 */
export const toPosts = (posts, slug) => {
    if (!posts.data) {
        return [];
    }

    return posts.data.filter((post) => post.description)
        .map((post) => ({
            ...post,
            date: toDate(post.date).fromNow(),
            htmlText: formatText(post.description),
        }))
        .map((post) => {
            if (slug && slug == post.slug && !store.getters.getComponentVisibility.dialog) {
                actions.updateComponentVisibility({
                    dialog: {
                        post
                    }
                });
            }

            return post;
        })
}

/**
 * Get panginated posts and optionally filter by slug
 * @param {string} posts
 * @param {string} slug
 */
 export const toPaginatedPosts = (posts, slug) => {
    return toPosts(posts, slug)
        .reduce((list, current, index) => {
            let page = 0;

            if (list.length > 0) {
                page = (list.length - 1);
            }

            if (index % Number(config.postsPerPage) && page != -1) {
                list[page].push(current)
            } else if (page > -1) {
                list[(page + 1)] = [current];
            } else if (page == -1) {
                list[1] = [current];
            }
            return list;
        }, []);
}

/**
 * Search a post
 * @param array posts
 * @param string str
 */
export const searchPost = (posts, str) => {
    if (!posts.data) {
        return [];
    }

    return {
        data: posts.data.filter((post) => post.title.toLowerCase().includes(str.toLowerCase()) || (post.htmlText || "").replace( /(<([^>]+)>)/ig, '').toLowerCase().includes(str.toLowerCase()))
    }
}

/**
 * Create post link
 * @param {string} slug
 */
export const toPostLink = (slug) => `${links.routes.post()}${slug}`
